<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Nuevo Contrato')">
        <br />
        <el-row>
          <el-col :md="12">
            <h2>{{ $t("Información General.") }}</h2>
          </el-col>
          <el-col :md="12">
            <StepsContrato v-bind:step="0"></StepsContrato>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!-- Seleccionar tipo de contrato-->
          <el-col :md="3">
            <span>{{ $t("Tipo de contrato") }}</span><br><br>
            <el-radio-group @change="setContractType" size="small" v-model="auxNewContract.tipo_contrato">
              <el-radio-button :label="$t('Propio')"></el-radio-button>
              <el-radio-button :label="$t('Contratista')"></el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col :md="4" style="text-align: center;" v-if="auxNewContract.tipo_contrato === 'Contratista'">
            <span>{{ $t("¿Es sub-contrato?") }}</span><br><br>
            <el-switch @change="setSubcontrato()" v-model="auxNewContract.subcontrato">
            </el-switch>
          </el-col>
        </el-row>
        <br><br>
        <el-row :gutter="20">
          <!-- Seleccionar área -->
          <el-col v-if="auxNewContract.tipo_contrato" :md="auxNewContract.tipo_contrato === 'Contratista' ? 8 : 19">
            <div>
              <span>{{ $t("Área") }}</span><br><br>
              <el-select v-model="auxNewContract.area_id" filterable size="small"
                placeholder="Buscar por nombre" class="w-100">
                <el-option v-for="area in areas" :key="area._id" :label="area.nombre" v-bind:value="area._id" />
              </el-select>
            </div>
          </el-col>
          <!-- Seleccionar empresa -->
          <el-col v-if="auxNewContract.tipo_contrato === 'Contratista'" :md="8">
            <div>
              <span>{{ $t("Empresa") }}</span><br><br>
              <el-select size="small" v-model="auxNewContract.empresa_id" filterable
                :placeholder="$t('Buscar por nombre o RUT')" class="w-100">
                <el-option v-for="emp in empresas" :key="emp._id" :label="emp.nombre + ' (' + emp.rut + ')'"
                  :value="emp._id" />
              </el-select>
            </div>
            <div class="mt-10">
              <small>{{ $t("¿No encuentras la empresa?") }}</small>
              <el-button type="primary" size="mini" class="ml-10" @click="dialogCompanyVisible = true">{{ $t("Crear")
                }}</el-button>
            </div>
          </el-col>
          <el-col :md="8" v-if="auxNewContract.subcontrato === true && auxNewContract.tipo_contrato === 'Contratista'">
            <span>{{ $t("Empresa mandante") }}</span><br><br>
            <el-select size="small" v-model="auxNewContract.subcontrato_empresa_id" filterable
              :placeholder="$t('Buscar por nombre o RUT')" class="w-100">
              <el-option v-for="emp in empresas" :key="emp._id" :label="emp.nombre + ' (' + emp.rut + ')'"
                :value="emp._id" />
            </el-select>
          </el-col>
        </el-row>
        <br />
        <hr />
        <br>
        <el-row :gutter="20">
          <el-col :md="24">
            <span>{{ $t("Nombre de contrato") }}</span><br><br>
            <el-input size="small" v-model="auxNewContract.nombre" :placeholder="$t('Ingresar nombre')" />
          </el-col>
        </el-row>
        <br>
        <el-row v-if="auxNewContract.tipo_contrato &&
        auxNewContract.tipo_contrato === 'Contratista'
        " :gutter="20">
          <el-col :md="8">
            <span>{{ $t("Número de contrato") }}</span><br><br>
            <el-input size="small" v-model="auxNewContract.numero_contrato"
              :placeholder="$t('Ingresar número de contrato')" />
          </el-col>

          <el-col :md="8">
            <span>{{ $t("Fecha inicio") }}</span><br><br>
            <el-date-picker size="small" v-model="auxNewContract.fecha_inicio" format="dd-MM-yyyy" type="date"
              :placeholder="$t('Escoger')" class="w-100" />
          </el-col>

          <el-col :md="8">
            <span>{{ $t("Fecha fin") }}</span><br><br>
            <el-date-picker size="small" format="dd-MM-yyyy" v-model="auxNewContract.fecha_fin" type="date"
              :placeholder="$t('Escoger')" class="w-100" />
          </el-col>
        </el-row>
        <br>
        <el-row v-if="auxNewContract.tipo_contrato &&
        auxNewContract.tipo_contrato === 'Contratista'
        " :gutter="20">
          <el-col :md="12">
            <span>{{ $t("Alcance del contrato") }}</span><br><br>
            <el-input size="small" type="textarea" v-model="auxNewContract.alcance"
              :placeholder="$t('Ingresar alcance')" />
          </el-col>
          <el-col :md="12">
            <span>{{ $t("Alcance del trabajo") }}</span><br><br>
            <el-input size="small" type="textarea" v-model="auxNewContract.alcance_trabajo"
              :placeholder="$t('Ingresar alcance')" />
          </el-col>
        </el-row>
        <br />
        <br />
        <el-row>
          <el-col :span="24" class="centrar">
            <el-button-group>
              <el-button type="primary" @click="backStep()" icon="el-icon-arrow-left">Regresar</el-button>
              <el-button :loading="isLoading" @click="nextStep()" type="primary">
                {{ $t("Siguiente") }}
                <i class="el-icon-arrow-right el-icon-right"></i>
              </el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <!-- Dialogs -->
    <!--Nueva empresa-->
    <el-dialog :title="$t('Crear empresa')" :visible="dialogCompanyVisible" width="40%" :before-close="handleClose">
      <el-form :inline="true" label-position="top" :model="nuevaEmp" ref="nuevo" label-width="105px"
        class="demo-form-inline">
        <el-form-item :label="$t('Nombre')" prop="nombre">
          <el-input v-model="nuevaEmp.nombre" placeholder />
        </el-form-item>
        <el-form-item :label="$t('RUT')" prop="rut">
          <el-input v-model="nuevaEmp.rut" placeholder />
        </el-form-item>
        <el-form-item :label="$t('Nombre de contacto')" prop="contacto">
          <el-input v-model="nuevaEmp.contacto" placeholder />
        </el-form-item>
        <el-form-item :label="$t('E-mail')" prop="email">
          <el-input v-model="nuevaEmp.email" placeholder />
        </el-form-item>
        <el-form-item :label="$t('Teléfono')" prop="fono">
          <el-input type="number" v-model="nuevaEmp.fono" placeholder />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCompanyVisible = false">{{
        $t("Cancelar")
      }}</el-button>
        <el-button type="primary" @click="submitForm('nuevo')">{{
        $t("Crear")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import StepsContrato from "@/components/contracts/StepsContrato.vue";

export default {
  name: "wizard",
  components: {
    StepsContrato,
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      // Contrato
      auxNewContract: {},
      // Empresa
      nuevaEmp: {
        nombre: "",
        contacto: "",
        email: "",
        rut: "",
        fono: "",
        faena_id: this.$store.getters.role.faena_id,
      },
      nuevo: {
        faena_id: this.$store.getters.role.faena_id,
      },
      dialogCompanyVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      newContract: "newContract",
      empresas: "empresas",
      areas: "areas",
    }),
  },
  created() {
    this.getEmpresasFaena();
    this.getAreasFaena();
    this.auxNewContract = Object.assign({}, this.newContract);
  },
  methods: {
    ...mapActions([
      "getEmpresasFaena",
      "saveEmpresa",
      "getAreasFaena",
      "saveArea",
      "userExists",
      "setNewContract",
    ]),
    setContractType(label) {
      if (label === "Propio") {
        this.auxNewContract.subcontrato = false;
        this.auxNewContract.subcontrato_empresa_id = "";
      }
    },
    setSubcontrato() {
      if (this.auxNewContract.subcontrato === false) {
        this.auxNewContract.subcontrato_empresa_id = "";
      }
    },
    backStep() {
      window.history.back();
    },
    nextStep() {
      this.isLoading = true;
      // Validar info
      let valid = true;
      if (
        !this.auxNewContract.tipo_contrato ||
        !this.auxNewContract.area_id ||
        !this.auxNewContract.nombre ||
        (this.auxNewContract.tipo_contrato === "Contratista" &&
          (!this.auxNewContract.empresa_id ||
            !this.auxNewContract.numero_contrato ||
            !this.auxNewContract.fecha_inicio ||
            !this.auxNewContract.fecha_fin ||
            !this.auxNewContract.alcance ||
            !this.auxNewContract.alcance_trabajo))
      ) {
        valid = false;
      }

      if (valid) {
        this.setNewContract(this.auxNewContract);
        this.$router.push({ name: "contractCreateStep2" });
      } else {
        this.$message({
          message:
            "Atención, Para continuar debes completar todos los campos requeridos.",
          type: "warning",
        });
      }
      this.isLoading = false;
    },
    handleClose(done) {
      this.dialogCompanyVisible = false;
      done();
    },
    // Save Empresa
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveEmpresa(this.nuevaEmp).then((response) => {
            if (response === true) {
              this.getEmpresasFaena();
              this.dialogCompanyVisible = false;
              this.nuevaEmp = {
                nombre: "",
                contacto: "",
                email: "",
                rut: "",
                fono: "",
                faena_id: this.$store.getters.role.faena_id,
              };
              this.$notify.success({
                title: this.$t("Creada"),
                message: this.$t("Empresa creada con éxito"),
                customClass: "notification",
              });
            } else {
              this.errorSubmit(response);
            }
          });
          return true;
        }
        return false;
      });
    },
    errorSubmit(message) {
      this.$notify.error({
        title: "Error",
        message,
        customClass: "notification",
      });
    },
  },
};
</script>

<style scoped>
.separator {
  margin: 30px 0;
}

.seleccionar {
  text-align: center;
}

.el-select {
  width: 50%;
}

.centrar {
  text-align: center;
}
</style>
